import {
  AccordionItem,
  List,
  Stack,
  Text,
  TextLink,
} from 'braid-design-system';
export const YourObligations = () => (
  <AccordionItem id="your-obligations" label="Your Obligations">
    <List type="number" start={31}>
      <Stack space="medium">
        <Text>
          In addition to the warranties outlined in our{' '}
          <TextLink href="/support/termsconditions">
            Advertiser Terms of Use
          </TextLink>
          , you warrant that:
        </Text>
        <List type="alpha">
          <Stack space="medium">
            <Text>
              your Systems that processes or stores our non-public data and
              Data:
            </Text>
            <List type="roman">
              <Text>will encrypt data transmitted over a public network;</Text>
              <Text>will encrypt data at rest;</Text>
              <Text>
                has enforced security monitoring controls to detect indicators
                of security incidents;
              </Text>
              <Text>has a documented process for responding to Incidents;</Text>
              <Text>
                has documented operational management procedures to ensure that
                necessary security controls are in place (antivirus, data loss
                prevention, etc.) and patches are applied in a timely manner;
              </Text>
              <Text>
                will document a provisioning and de-provisioning process for
                internal business users;
              </Text>
              <Text>
                will enforce controls like single sign-on and multi-factor
                authentication for internal business users;
              </Text>
              <Text>will generate and retain audit logs; and</Text>
              <Text>is covered by a documented Business Continuity Plan;</Text>
            </List>
          </Stack>
          <Stack space="medium">
            <Text>
              you will maintain security controls to reasonably secure your
              Recruitment Software and to protect the Data from misuse,
              interference, loss and unauthorised access, modification or
              disclosure, including, without limitation to:
            </Text>
            <List type="roman">
              <Text>
                the use of anti-malware software on Systems providing or
                supporting your Recruitment Software;
              </Text>
              <Text>
                the use of firewalls and related security controls to restrict
                unauthorised access to your Recruitment Software and the Data
                from the Internet and other untrusted networks connected to the
                Systems;
              </Text>
              <Text>
                the regular maintenance and updating of security controls for
                your Systems;
              </Text>
              <Text>
                the regular monitoring of your Systems for any event that may
                compromise the security of your Systems, your Recruitment
                Software or the Data; and
              </Text>
              <Text>the regular backup of your Systems;</Text>
            </List>
          </Stack>
          <Text>
            you, and your Recruitment Software complies, in all material
            aspects, with the requirements of the Australian Spam Act 2003 (Cth)
            and all other relevant or similar direct marketing laws that may be
            applicable to you;
          </Text>
          <Text>
            your Recruitment Software does not breach the intellectual property
            rights of any third party;
          </Text>
          <Text>
            you will not act for, or on behalf of, an Advertiser without their
            express written consent;
          </Text>
          <Text>
            you have no proprietary right, title to, or interest in the Data,
            and you will not use the Data for any purpose other than the
            transfer of said Data to the Advertiser that has engaged you;
          </Text>
          <Text>
            you will not copy or store any Data for any purpose other than the
            transfer of said Data to the Advertiser that has engaged you;
          </Text>
          <Text>
            when transmitting Data to a Mutual Customers you will not alter,
            modify or amend the Data in any material way (this obligation does
            not restrict you however from sorting the Data in accordance with
            the instructions of the Mutual Customer);
          </Text>
          <Text>
            you will not develop your Recruitment Software, or use the SEEK API
            or Data in a way that may harm the professional reputation or
            relationships of the Advertisers and Candidates; and
          </Text>
          <Text>
            you will not use, distribute, or transfer the SEEK API or Data for
            any illegal purposes, or in any manner which would violate these
            Terms, or expose the SEEK Group or its Advertisers and Candidates to
            legal liability.
          </Text>
        </List>
      </Stack>
      <Text>
        You may not assign or transfer any rights and obligations pursuant to
        these Terms to any other person or entity without our prior written
        approval (which will not be unreasonably withheld). If you are a
        company, any change in your effective control shall be deemed an
        assignment requiring our consent under the terms of this clause.
      </Text>
      <Text>
        You agree to assist us in verifying your compliance with obligations
        under these Terms by providing any requested information to us that is
        reasonably required to ascertain your compliance.
      </Text>
    </List>
  </AccordionItem>
);
